import { CopyButton, FormInput } from '@/components';
import React from 'react';
interface ShareReferralCodeFormInputProps {
  referralCode: string;
}
const ShareReferralCodeFormInput: React.FC<ShareReferralCodeFormInputProps> = ({
  referralCode,
}) => {
  return (
    <FormInput
      readOnly
      label="Your personal referral code"
      name="personalReferralCode"
      type="text"
      value={referralCode}
      suffix={
        <CopyButton value={referralCode} showLabel={false} iconSize="md" />
      }
    ></FormInput>
  );
};
export default ShareReferralCodeFormInput;
